import React, { useEffect } from 'react';
import { useForm } from '@formspree/react';
import './ContactForm.css';

const ContactForm = ({ onSubmitSuccess }) => {
  const projectId = process.env.REACT_APP_FORMSPREE_PROJECT_ID;
  const [state, handleSubmit] = useForm("contactForm", {
    project: projectId
  });

  useEffect(() => {
    if (state.succeeded) {
      const formElement = document.getElementById('contact-form');
      if (formElement) {
        const formData = new FormData(formElement);
        const data = {
          name: formData.get('name'),
          email: formData.get('email')
        };
        onSubmitSuccess(data);
      }
    }
  }, [state.succeeded, onSubmitSuccess]);

  return (
    <div className="contact-form-container">
      <div className="contact-form-card">
        <h2>Hi, I'm Vira!</h2>
        <p>I'm Bryon's assistant. I'll need to collect your contact information so we can follow up after our conversation.</p>
        <form id="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              placeholder="Enter your name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              placeholder="Enter your email"
            />
          </div>
          <button type="submit" disabled={state.submitting}>
            {state.submitting ? 'Submitting...' : 'Continue'}
          </button>
          {state.errors && state.errors.length > 0 && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              Error submitting form. Please try again.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;